export default __webpack_public_path__ + "static/media/other08.7b67182f.webp";